import React from "react";
import Welcome from "../../containers/app/Welcome";
import Login from "../../containers/login/Login";
import Cards from "../../containers/card/Cards";
import Pin from "../../containers/card/Pin";
import ThankYou from "../../containers/app/ThankYou";
import Loader from "../app/Loader";
import { Stages } from "../../actions/actions";
import { getToken, init, setTokenHeader, getCards } from "../../actions/services";
import MessageScreen from "./MessageScreen";

export default class Page extends React.Component {
  render() {
    let _this = this;

    var customError = "";
    var queryString = window.parent.location.search;
    const urlParams = new URLSearchParams(queryString);
    const index = urlParams.get("sid");

    if (index) {
      _this.props.onSetLoader(true);
      getToken(index)
        .then((response) => {
          if (response.data.calConnectToken) {
            setTokenHeader(response.data.calConnectToken, window.isCalProvider);

            init()
              .then((response) => {
                getCards()
                  .then((cardsResponse) => {
                    if (cardsResponse.data.statusCode != 1 && cardsResponse.data.statusCode != -1 && cardsResponse.data.statusCode != 69) {
                      customError = cardsResponse;
                      throw new Error(cardsResponse);
                    }

                    _this.props.setPopulateCards(cardsResponse.data.result.cards);
                    _this.props.selectCard(cardsResponse.data.result.cards[0].last4Digits);
                    _this.props.onSetStage(Stages.cards);
                    _this.props.onSetLoader(false);
                  })
                  .catch((error) => {
                    if (customError != "") {
                      error.response = customError;
                      let text;
                      let status;
                      if (error.response.data.statusDescription != null) text = error.response.data.statusDescription;
                      if (error.response.data.statusCode != 1) status = error.response.data.statusCode;

                      _this.props.setError(status, text);
                    } else {
                      if (error.response) {
                        _this.props.setError(500, error.response.data.statusDescription);
                      } else if (error.message) {
                        if (error.message == "Network Error") {
                          error.message = "שגיאת רשת - השירות אינו זמין";
                        }
                        error.response = {};
                        error.response.data = {};
                        error.response.data = error.message;
                        _this.props.setError(503, error.message);
                      }
                    }

                    _this.props.onSetStage(Stages.login);
                    _this.props.onSetLoader(false);
                  });
              })
              .catch((error) => {
                if (error.response.status == 503) {
                  _this.props.setError(503, "השירות אינו זמין");
                } else {
                  if (error.response.status !== 401) {
                    _this.props.setError(500, error.response.data.statusDescription);
                  }
                }
                _this.props.onSetStage(Stages.login);
                _this.props.onSetLoader(false);
              });
          } else {
            _this.props.onSetStage(Stages.login);
            _this.props.onSetLoader(false);
          }
        })
        .catch((error) => {
          _this.props.onSetStage(Stages.login);
          _this.props.onSetLoader(false);
        });
    }
    
    switch (this.props.stage) {
      case Stages.loader:
        return <Loader />;
      case Stages.welcome:
        return <Welcome source={this.props.source} onNext={() => this.props.onSetStage(Stages.login)} />;
      case Stages.login:
        return <Login />;
      case Stages.cards:
        return <Cards provider={this.props.provider} isConnected={this.props.isConnected} />;
      case Stages.pin:
        return <Pin provider={this.props.provider} />;
      case Stages.thankYou:
        return <ThankYou provider={this.props.provider} onBack={() => this.props.onSetStage(Stages.login)} />;
      case Stages.error:
        return (
          <MessageScreen
            message={Stages.error.text}
            provider={this.props.provider}
            onTryAgain={this.props.onGetCards}
            onClose={this.props.onCloseMessage}
            type="error"
          />
        );
      default:
        this.props.onSetStage(Stages.login);

        return null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/app/Page.jsx